import { Stack, Grid, Typography } from "@mui/material";

export const TalentTitle = () => {
  return (
    <Stack mb={4}>
      <Grid container gap={2}>
        <Typography variant="head24Bold">新規人材登録</Typography>
      </Grid>
    </Stack>
  );
};
